import { TESTIMONIALS } from "@/mocks/content";
import { Eyebrow } from "@/components/ui/primitives";

const AVATAR_TONE = ["bg-primary-500/20 text-primary-300", "bg-accent-500/20 text-accent-300", "bg-secondary-500/20 text-secondary-300", "bg-primary-500/20 text-primary-300"];

export default function Testimonials() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 max-w-2xl">
          <Eyebrow text="创作者口碑" en="Voices" />
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            那些被片场记住的人怎么说
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            导演、录音、摄影、学生……幕外的读者和受访者，用各自的方式重新理解了“幕后”两个字的分量。
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <div className="flex items-center gap-1 text-primary-400">
                {Array.from({ length: 5 }).map((_, k) => (
                  <i key={k} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.content}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className={`flex h-11 w-11 items-center justify-center rounded-full font-heading text-base font-semibold ${AVATAR_TONE[i % AVATAR_TONE.length]}`}>
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}